
import { useState } from 'react';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    // 1. 「自分も対象かどうか」の不安を解消
    {
      question: 'マンション・アパートでも対応できますか？',
      answer: '<strong>はい、対応可能です。</strong>賃貸住宅の場合は、事前に管理会社や大家さんへご確認をお願いいたします。',
    },
    {
      question: '古いエアコンでも大丈夫ですか？',
      answer: '<strong>基本的には対応可能です。</strong>製造から10年以上経過している場合は、事前にお知らせください。',
    },
    // 2. 料金や条件など、隠しがちな情報を明確に
    {
      question: '呉市の場合、出張費はかかりますか？',
      answer: '<strong>呉市は出張費1,000円をお願いしています。</strong>江田島市は全域出張費無料です。',
    },
    {
      question: '管理会社や大家さんへの確認は必要ですか？',
      answer: '<strong>基本的には必要となる場合が多いです。</strong>ご不明な場合は、事前にご相談いただければアドバイスいたします。',
    },
    // 3. 作業当日の流れが具体的にイメージできる
    {
      question: '作業時間はどれくらいかかりますか？',
      answer: '<strong>お掃除機能なしで約1〜1.5時間、お掃除機能ありで約2〜3時間が目安です。</strong>汚れ具合により前後する場合があります。',
    },
    {
      question: '作業当日に準備しておくことはありますか？',
      answer: '<strong>エアコン下の家具や家電を、可能な範囲で移動していただけると助かります。</strong>移動が難しい場合は、事前にご相談ください。',
    },
    {
      question: '駐車場は必要ですか？',
      answer: '<strong>作業車を1台使用しますので、駐車スペースをお借りできると助かります。</strong>難しい場合は事前にご相談ください。',
    },
    // 4. 安心感や信頼感（養生、保険、配慮）
    {
      question: '壁や床が汚れることはありませんか？',
      answer: '<strong>作業前に床や壁の養生を行い、細心の注意を払って作業します。</strong>万が一に備え、賠償責任保険にも加入しています。',
    },
    {
      question: '女性スタッフは同行できますか？',
      answer: '<strong>はい、ご希望があれば女性スタッフの同行が可能です。</strong>出勤日が限られているため、事前にご相談ください。',
    },
    {
      question: 'どのくらいの頻度でクリーニングが必要ですか？',
      answer: '<strong>1〜2年に1回のクリーニングがおすすめです。</strong>小さなお子様やペットがいるご家庭では、より早めのクリーニングをおすすめしています。',
    },
    // 5. 「今、問い合わせてみよう」と思える質問で締める
    {
      question: '予約はどれくらい前にすればいいですか？',
      answer: '<strong>空き状況によっては直前のご予約も可能です。</strong>ご希望日時がある場合は、1〜2週間前のご予約をおすすめしています。',
    },
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="py-16 px-4 bg-gradient-to-b from-cyan-50 to-white">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12">
          よくある質問
        </h2>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl shadow-md overflow-hidden transition-all duration-300 hover:shadow-lg"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full text-left p-6 flex items-center justify-between gap-4 cursor-pointer"
              >
                <div className="flex items-start gap-4 flex-1">
                  <div className="w-10 h-10 flex items-center justify-center bg-cyan-100 rounded-full flex-shrink-0">
                    <span className="text-lg font-bold text-cyan-600">Q</span>
                  </div>
                  <h3 className="text-base font-bold text-gray-900 leading-relaxed pt-2 text-left">
                    {faq.question}
                  </h3>
                </div>
                <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                  <i
                    className={`ri-arrow-down-s-line text-2xl text-gray-600 transition-transform duration-300 ${
                      openIndex === index ? 'rotate-180' : ''
                    }`}
                  ></i>
                </div>
              </button>

              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <div className="px-6 pb-6">
                  <div className="flex items-start gap-4 pl-14">
                    <div className="w-10 h-10 flex items-center justify-center bg-yellow-100 rounded-full flex-shrink-0">
                      <span className="text-lg font-bold text-yellow-600">A</span>
                    </div>
                    <p 
                      className="text-base text-gray-700 font-normal leading-relaxed pt-2 text-left"
                      dangerouslySetInnerHTML={{ __html: faq.answer }}
                    />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="mt-10 text-center">
          <p className="text-gray-700 font-normal text-base leading-relaxed mb-4">
            その他のご質問は、<br className="md:hidden" />お気軽にお問い合わせください。
          </p>
          <a
            href="https://lin.ee/ltlhjZa"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-white border-2 border-[#06C755] text-[#06C755] hover:bg-[#06C755]/10 font-bold py-3 px-6 rounded-full transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-line-fill text-lg"></i>
            <span>LINEで質問する</span>
          </a>
        </div>
      </div>
    </section>
  );
}
